import styled from "styled-components";
import * as React from "react";

import { Text } from "src/library/components/Text";
import { ScheduleStatus } from "src/core/schedules/api/schedules.api";

export interface ScheduleStatusTextProps {
  status: ScheduleStatus,
  hasErrors?: boolean;
}

export const StyledText = styled(Text)<ScheduleStatusTextProps>`
  color: ${({
    theme, status, hasErrors
  }) => {
    if (hasErrors) {
      return theme.colors.errorOrder;
    }

    if (status === ScheduleStatus.Active) {
      return theme.colors.success;
    } else if (status === ScheduleStatus.Cancelled) {
      return theme.colors.errorOrder;
    } else if (status === ScheduleStatus.Suspended) {
      return theme.colors.errorOrder;
    }

    return "";
  }};
`;

/**
 * Schedule status
 * If status is suspended, display cancelled word to avoid users thinking schedule will automatically start in the future
 */
export const ScheduleStatusText: React.ReactFCWithChildren<ScheduleStatusTextProps> = ({ status, hasErrors }) => {
  return (
    <StyledText
      status={status}
      hasErrors={hasErrors}
      weight="bold"
    >
      {hasErrors ? "Has errors" : status === ScheduleStatus.Suspended ? ScheduleStatus.Cancelled : status}
    </StyledText>
  );
};

export default ScheduleStatusText;
